// Всплывающая плашка — замена статус-бару на телефоне.
//
// Статус-бар держал часы (они и так есть в телефоне), надпись «буфер сохранён
// на сервере» (статичная и ни о чём) и счётчик окон (переехал в меню). Ради
// этого он занимал 32 px плюс домашнюю полосу. Осталось то, ради чего туда
// вообще смотрели: потеря связи, новая версия и разовые сообщения об ошибках.
//
// Плашки висят под шапкой, а не над нижними кнопками, и не перехватывают
// нажатия — почему именно так, подробно в Toast.css.

import { useEffect, useState } from 'react'
import { BOOT_HINT_AFTER_MS, bootText, useBooting } from '../lib/booting'
import { useAppStore } from '../store/appStore'
import './Toast.css'

/** Сколько живёт разовое сообщение.
 *
 *  Раньше оно не гасло вообще: закрыть можно было только тапом по крестику.
 *  На телефоне это значило, что после любой сетевой ошибки плашка оставалась
 *  на экране навсегда — вместе со всеми её побочными эффектами. Сообщение об
 *  ошибке разовое по смыслу: прочитали — ушло. 6 секунд хватает на строку
 *  текста и не заставляет ловить крестик. */
const NOTICE_MS = 6000

export default function Toast() {
  const online = useAppStore((s) => s.online)
  const updateReady = useAppStore((s) => s.updateReady)
  const installUpdate = useAppStore((s) => s.installUpdate)
  const notice = useAppStore((s) => s.notice)
  const setNotice = useAppStore((s) => s.setNotice)

  // Таймер перезапускается на каждое новое сообщение: вторая ошибка подряд
  // получает свои полные 6 секунд, а не остаток от предыдущей.
  useEffect(() => {
    if (!notice) return
    const timer = window.setTimeout(() => setNotice(null), NOTICE_MS)
    return () => window.clearTimeout(timer)
  }, [notice, setNotice])

  // Подъём сессии дольше нескольких секунд — плашка ожидания с секундами
  // (lib/booting.ts); тикает, только пока такой запрос идёт.
  const jobs = useBooting((s) => s.jobs)
  const [now, setNow] = useState(() => Date.now())
  const oldest = Object.values(jobs).sort((a, b) => a.since - b.since)[0]
  useEffect(() => {
    if (!oldest) return
    setNow(Date.now())
    const timer = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(timer)
  }, [oldest])
  const boot = oldest && now - oldest.since >= BOOT_HINT_AFTER_MS ? bootText(oldest, now) : null

  if (online && !updateReady && !notice && !boot) return null

  return (
    <div className="ab-toasts" role="status" aria-live="polite">
      {!online ? (
        // Состояние, а не действие: нажимать нечего, поэтому это div, а не
        // кнопка, и он прозрачен для нажатий (см. .ab-toast--warn).
        <div className="ab-toast ab-toast--warn">
          нет сети · панель работает из кеша
        </div>
      ) : null}

      {updateReady ? (
        <button className="ab-toast ab-toast--go" onClick={installUpdate}>
          новая версия готова · обновить
        </button>
      ) : null}

      {boot ? <div className="ab-toast ab-toast--wait">{boot}</div> : null}

      {notice ? (
        <button className="ab-toast" onClick={() => setNotice(null)}>
          {notice}
          <span className="ab-toast__x" aria-hidden>×</span>
        </button>
      ) : null}
    </div>
  )
}
